import React, { useMemo } from 'react';
// import Table from 'react-bootstrap/Table';

import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import './index.css';
import Button from 'react-bootstrap/Button';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import './index.css';
import { useRecoilState } from 'recoil';
import { showHideTable, showHideBreadcrumbsAtom, showHideModalAtom } from '../../Services/_states';
import { BreadCrumbData } from './BreadCrumb';
import WhatsappModal from '../common/Modals/WhatsappModal';
import FosRmTable from './FosRmTable';
import CommonTable from '../Table/CommonTable';

export default function ViewClientAgencyTable(props) {
  const [isExpandRow, setIsExpandRow] = React.useState({ b2b: false, b2c: false });
  const [selectedId, setSelectedId] = React.useState('');
  const [showHideTableObj, setshowHideTableObj] = useRecoilState(showHideTable);
  const [showHideBreadCrumbs, setShowHideBreadCrumbs] = useRecoilState(showHideBreadcrumbsAtom);
  const [showHideModal, setshowHideModal] = useRecoilState(showHideModalAtom);

  const headerData = [
    {
      name: 'S.No.',
    },
    {
      name:
        showHideBreadCrumbs.first.tableName === 'View Client Wise' ? 'Client Name' : 'Agency Name',
    },
    {
      name: 'To be Shared',
    },
    {
      name: 'Count',
    },
    {
      name: 'Lead accepted by QA',
      tooltip: 'Lead accepted by QA',
    },
    {
      name: 'Lead Accepted by Client',
      tooltip: 'Lead accepted by Client',
    },
    {
      name: 'Comment Updated',
    },
    {
      name: 'Status Updated',
    },
    {
      name: 'Revenue Earned',
    },
    {
      name: 'View Campaign',
    },
    {
      name: 'Action',
    },
  ];

  async function onClickCampaign(btnName) {
    await setshowHideTableObj({
      ...showHideTableObj,
      ViewCampaignWise: true,
      ViewClientWise: false,
    });
    setShowHideBreadCrumbs({ ...showHideBreadCrumbs, second: { show: true, tableName: btnName } });
  }

  const bodyData = () => {
    let data = [
      {
        sno: '1',
        name: 'Asian Paints 1',
        sharedCount: '6000',
        leadCount: '5000',
        leadQA: '3000',
        leadClient: '3000',
        commentUpdate: '3000',
        statusUpdate: '3000',
        revenue: '30k',
        campaignWise: (
          <Button
            variant="outline-dark"
            className="lead-btn"
            onClick={() => onClickCampaign('View Campaign Wise')}
          >
            View Campaign Wise
          </Button>
        ),
        action: (
          <div className="action-icon">
            <span
              className="action-icon-item"
              onClick={(e) => {
                setshowHideModal({ ...showHideModal, email: { show: true } });
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-envelope-at-fill"
                viewBox="0 0 16 16"
              >
                <path d="M2 2A2 2 0 0 0 .05 3.555L8 8.414l7.95-4.859A2 2 0 0 0 14 2zm-2 9.8V4.698l5.803 3.546zm6.761-2.97-6.57 4.026A2 2 0 0 0 2 14h6.256A4.5 4.5 0 0 1 8 12.5a4.49 4.49 0 0 1 1.606-3.446l-.367-.225L8 9.586zM16 9.671V4.697l-5.803 3.546.338.208A4.5 4.5 0 0 1 12.5 8c1.414 0 2.675.652 3.5 1.671" />
                <path d="M15.834 12.244c0 1.168-.577 2.025-1.587 2.025-.503 0-1.002-.228-1.12-.648h-.043c-.118.416-.543.643-1.015.643-.77 0-1.259-.542-1.259-1.434v-.529c0-.844.481-1.4 1.26-1.4.585 0 .87.333.953.63h.03v-.568h.905v2.19c0 .272.18.42.411.42.315 0 .639-.415.639-1.39v-.118c0-1.277-.95-2.326-2.484-2.326h-.04c-1.582 0-2.64 1.067-2.64 2.724v.157c0 1.867 1.237 2.654 2.57 2.654h.045c.507 0 .935-.07 1.18-.18v.731c-.219.1-.643.175-1.237.175h-.044C10.438 16 9 14.82 9 12.646v-.214C9 10.36 10.421 9 12.485 9h.035c2.12 0 3.314 1.43 3.314 3.034zm-4.04.21v.227c0 .586.227.8.581.8.31 0 .564-.17.564-.743v-.367c0-.516-.275-.708-.572-.708-.346 0-.573.245-.573.791" />
              </svg>
            </span>
            <span className="action-icon-item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-arrow-down-circle-fill"
                viewBox="0 0 16 16"
              >
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293z" />
              </svg>
            </span>
            <span
              className="action-icon-item"
              onClick={(e) => {
                setshowHideModal({ ...showHideModal, whatsapp: { show: true } });
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-whatsapp"
                viewBox="0 0 16 16"
              >
                <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
              </svg>
            </span>
          </div>
        ),
      },
      {
        sno: '2',
        name: 'Client 1',
        sharedCount: '6000',
        leadCount: '5000',
        leadQA: '3000',
        leadClient: '3000',
        commentUpdate: '3000',
        statusUpdate: '3000',
        revenue: '30k',
        campaignWise: (
          <Button
            variant="outline-dark"
            className="lead-btn"
            onClick={() => onClickCampaign('View Campaign Wise')}
          >
            View Campaign Wise
          </Button>
        ),
        action: (
          <div className="action-icon">
            <span
              className="action-icon-item"
              onClick={(e) => {
                setshowHideModal({ ...showHideModal, email: { show: true } });
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-envelope-at-fill"
                viewBox="0 0 16 16"
              >
                <path d="M2 2A2 2 0 0 0 .05 3.555L8 8.414l7.95-4.859A2 2 0 0 0 14 2zm-2 9.8V4.698l5.803 3.546zm6.761-2.97-6.57 4.026A2 2 0 0 0 2 14h6.256A4.5 4.5 0 0 1 8 12.5a4.49 4.49 0 0 1 1.606-3.446l-.367-.225L8 9.586zM16 9.671V4.697l-5.803 3.546.338.208A4.5 4.5 0 0 1 12.5 8c1.414 0 2.675.652 3.5 1.671" />
                <path d="M15.834 12.244c0 1.168-.577 2.025-1.587 2.025-.503 0-1.002-.228-1.12-.648h-.043c-.118.416-.543.643-1.015.643-.77 0-1.259-.542-1.259-1.434v-.529c0-.844.481-1.4 1.26-1.4.585 0 .87.333.953.63h.03v-.568h.905v2.19c0 .272.18.42.411.42.315 0 .639-.415.639-1.39v-.118c0-1.277-.95-2.326-2.484-2.326h-.04c-1.582 0-2.64 1.067-2.64 2.724v.157c0 1.867 1.237 2.654 2.57 2.654h.045c.507 0 .935-.07 1.18-.18v.731c-.219.1-.643.175-1.237.175h-.044C10.438 16 9 14.82 9 12.646v-.214C9 10.36 10.421 9 12.485 9h.035c2.12 0 3.314 1.43 3.314 3.034zm-4.04.21v.227c0 .586.227.8.581.8.31 0 .564-.17.564-.743v-.367c0-.516-.275-.708-.572-.708-.346 0-.573.245-.573.791" />
              </svg>
            </span>
            <span className="action-icon-item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-arrow-down-circle-fill"
                viewBox="0 0 16 16"
              >
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293z" />
              </svg>
            </span>
            <span
              className="action-icon-item"
              onClick={(e) => {
                setshowHideModal({ ...showHideModal, whatsapp: { show: true } });
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-whatsapp"
                viewBox="0 0 16 16"
              >
                <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
              </svg>
            </span>
          </div>
        ),
      },
      {
        sno: '3',
        name: 'Asian Paints 1',
        sharedCount: '6000',
        leadCount: '5000',
        leadQA: '3000',
        leadClient: '3000',
        commentUpdate: '3000',
        statusUpdate: '3000',
        revenue: '30k',
        campaignWise: (
          <Button
            variant="outline-dark"
            className="lead-btn"
            onClick={() => onClickCampaign('View Campaign Wise')}
          >
            View Campaign Wise
          </Button>
        ),
        action: (
          <div className="action-icon">
            <span
              className="action-icon-item"
              onClick={(e) => {
                setshowHideModal({ ...showHideModal, email: { show: true } });
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-envelope-at-fill"
                viewBox="0 0 16 16"
              >
                <path d="M2 2A2 2 0 0 0 .05 3.555L8 8.414l7.95-4.859A2 2 0 0 0 14 2zm-2 9.8V4.698l5.803 3.546zm6.761-2.97-6.57 4.026A2 2 0 0 0 2 14h6.256A4.5 4.5 0 0 1 8 12.5a4.49 4.49 0 0 1 1.606-3.446l-.367-.225L8 9.586zM16 9.671V4.697l-5.803 3.546.338.208A4.5 4.5 0 0 1 12.5 8c1.414 0 2.675.652 3.5 1.671" />
                <path d="M15.834 12.244c0 1.168-.577 2.025-1.587 2.025-.503 0-1.002-.228-1.12-.648h-.043c-.118.416-.543.643-1.015.643-.77 0-1.259-.542-1.259-1.434v-.529c0-.844.481-1.4 1.26-1.4.585 0 .87.333.953.63h.03v-.568h.905v2.19c0 .272.18.42.411.42.315 0 .639-.415.639-1.39v-.118c0-1.277-.95-2.326-2.484-2.326h-.04c-1.582 0-2.64 1.067-2.64 2.724v.157c0 1.867 1.237 2.654 2.57 2.654h.045c.507 0 .935-.07 1.18-.18v.731c-.219.1-.643.175-1.237.175h-.044C10.438 16 9 14.82 9 12.646v-.214C9 10.36 10.421 9 12.485 9h.035c2.12 0 3.314 1.43 3.314 3.034zm-4.04.21v.227c0 .586.227.8.581.8.31 0 .564-.17.564-.743v-.367c0-.516-.275-.708-.572-.708-.346 0-.573.245-.573.791" />
              </svg>
            </span>
            <span className="action-icon-item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-arrow-down-circle-fill"
                viewBox="0 0 16 16"
              >
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293z" />
              </svg>
            </span>
            <span
              className="action-icon-item"
              onClick={(e) => {
                setshowHideModal({ ...showHideModal, whatsapp: { show: true } });
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-whatsapp"
                viewBox="0 0 16 16"
              >
                <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
              </svg>
            </span>
          </div>
        ),
      },
    ];

    let body = data.map((ele, index) => {
      return (
        <>
          <Tr className={selectedId === ele.type ? 'nested-table' : ''} key={index}>
            <Td
              className="sn-table"
              onClick={(e) => {
                setSelectedId(selectedId === ele.sno ? '' : ele.sno);
              }}
            >
              {selectedId === ele.sno ? (
                <span className="cell-toggler">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-chevron-down"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                    />
                  </svg>
                </span>
              ) : (
                <span className="cell-toggler">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-chevron-up"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"
                    />
                  </svg>
                </span>
              )}
            </Td>
            <Td>{ele.sno}</Td>
            <Td>{ele.name}</Td>
            <Td>{ele.sharedCount}</Td>
            <Td>{ele.leadCount}</Td>
            <Td>{ele.leadQA}</Td>
            <Td>{ele.leadClient}</Td>
            <Td>{ele.commentUpdate}</Td>
            <Td>{ele.statusUpdate}</Td>
            <Td>{ele.revenue}</Td>
            <Td>{ele.campaignWise}</Td>
            <Td>{ele.action}</Td>
          </Tr>
          {selectedId === ele.sno && <FosRmTable styles={{ colSpan: 12 }} />}
        </>
      );
    });
    return body;
  };

  return (
    <>
      {/* <h4 style={{ paddingTop: '10px' }}>Client Wise</h4> */}
      <CommonTable headerData={headerData} bodyData={bodyData} />

      {/* <Table striped bordered hover className="leads-table ">
        <Thead className="leads-tbody">
          <Tr>
            <Th></Th>
            <Th>S.No.</Th>
            <Th>
              {showHideBreadCrumbs.first.tableName === 'View Client Wise'
                ? 'Client Name'
                : 'Agency Name'}
            </Th>
            <Th>To be Shared</Th>
            <Th>Count</Th>
            <Th> Accepted by QA</Th>
            <Th> Accepted by Client</Th>
            <Th>Comment updated</Th>
            <Th>Status updated</Th>
            <Th>Revenue Earned</Th>
            <Th>View Campaign</Th>
            <Th>Action</Th>
          </Tr>
        </Thead>
        <Tbody>
          <Tr className={isExpandRow.b2b ? 'nested-table' : ''}>
            <Td onClick={() => setIsExpandRow({ ...isExpandRow, b2b: !isExpandRow.b2b })}>
              {isExpandRow.b2b && <BsChevronUp />}
              {!isExpandRow.b2b && <BsChevronDown />}
            </Td>
            <Td>1</Td>
            <Td>Asian Paints 1</Td>
            <Td>5000</Td>
            <Td>3000</Td>
            <Td>3000</Td>
            <Td>3000</Td>
            <Td>3000</Td>
            <Td>3000</Td>
            <Td>3000</Td>
            <Td>
              {' '}
              <Button
                variant="outline-dark"
                className="lead-btn"
                onClick={() => onClickCampaign('View Campaign Wise')}
              >
                View Campaign
              </Button>
            </Td>
            <Td>
              <div className="action-icon">
                <span
                  onClick={(e) => {
                    setshowHideModal({ ...showHideModal, email: { show: true } });
                  }}
                >
                  <BsEnvelopeFill />
                </span>
                <span>
                  <BsArrowDownCircle />
                </span>
                <span
                  onClick={(e) => {
                    setshowHideModal({ ...showHideModal, whatsapp: { show: true } });
                  }}
                >
                  <BsWhatsapp />
                </span>
              </div>
            </Td>
          </Tr>
          {isExpandRow.b2b && (
            <Tr>
              <Td colSpan={12} className="nested-leads-table-colspan ">
                <Table striped bordered hover className="nested-leads-table ">
                  <Thead className="leads-Tbody">
                    <Tr>
                      <Th>S.No.</Th>
                      <Th>Lead Source</Th>
                      <Th>Total Lead Count Shared</Th>
                      <Th>Lead accepted by QA</Th>
                      <Th>Lead Accepted by Client</Th>
                      <Th> Action</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    <Tr>
                      <Td>1.1</Td>
                      <Td>FOS</Td>
                      <Td>5000</Td>
                      <Td>2500</Td>
                      <Td>2000</Td>
                      <Td>
                        <div className="action-icon">
                          <span
                            onClick={(e) => {
                              setshowHideModal({ ...showHideModal, email: { show: true } });
                            }}
                          >
                            <BsEnvelopeFill />
                          </span>
                          <span>
                            <BsArrowDownCircle />
                          </span>
                          <span
                            onClick={(e) => {
                              setshowHideModal({ ...showHideModal, whatsapp: { show: true } });
                            }}
                          >
                            <BsWhatsapp />
                          </span>
                        </div>
                      </Td>
                    </Tr>
                    <Tr>
                      <Td>2.1</Td>
                      <Td>RM</Td>
                      <Td>5000</Td>
                      <Td>2500</Td>
                      <Td>2000</Td>
                      <Td>
                        <div className="action-icon">
                          <span
                            onClick={(e) => {
                              setshowHideModal({ ...showHideModal, email: { show: true } });
                            }}
                          >
                            <BsEnvelopeFill />
                          </span>
                          <span>
                            <BsArrowDownCircle />
                          </span>
                          <span
                            onClick={(e) => {
                              setshowHideModal({ ...showHideModal, whatsapp: { show: true } });
                            }}
                          >
                            <BsWhatsapp />
                          </span>
                        </div>
                      </Td>
                    </Tr>
                  </Tbody>
                </Table>
              </Td>
            </Tr>
          )}

          <Tr>
            <Td onClick={() => setIsExpandRow({ ...isExpandRow, b2b: !isExpandRow.b2b })}>
              <BsChevronDown />{' '}
            </Td>
            <Td>2</Td>
            <Td>Clinet 1</Td>
            <Td>5000</Td>
            <Td>3000</Td>
            <Td>3000</Td>
            <Td>3000</Td>
            <Td>3000</Td>
            <Td>3000</Td>
            <Td>3000</Td>
            <Td>
              {' '}
              <Button
                variant="outline-dark"
                className="lead-btn"
                onClick={() =>
                  setshowHideTableObj({
                    ...showHideTableObj,
                    ViewCampaignWise: true,
                    ViewClientWise: false,
                  })
                }
              >
                View Campaign
              </Button>
            </Td>
            <Td>
              <div className="action-icon">
                <span
                  onClick={(e) => {
                    setshowHideModal({ ...showHideModal, email: { show: true } });
                  }}
                >
                  <BsEnvelopeFill />
                </span>
                <span>
                  <BsArrowDownCircle />
                </span>
                <span
                  onClick={(e) => {
                    setshowHideModal({ ...showHideModal, whatsapp: { show: true } });
                  }}
                >
                  <BsWhatsapp />
                </span>
              </div>
            </Td>
          </Tr>
          <Tr className={isExpandRow.b2b ? 'nested-table' : ''}>
            <Td onClick={() => setIsExpandRow({ ...isExpandRow, b2b: !isExpandRow.b2b })}>
              {isExpandRow.b2b && <BsChevronUp />}
              {!isExpandRow.b2b && <BsChevronDown />}
            </Td>
            <Td>3</Td>
            <Td>Clinet 1</Td>
            <Td>5000</Td>
            <Td>3000</Td>
            <Td>3000</Td>
            <Td>3000</Td>
            <Td>3000</Td>
            <Td>3000</Td>
            <Td>3000</Td>
            <Td>
              {' '}
              <Button
                variant="outline-dark"
                className="lead-btn"
                onClick={() => onClickCampaign('View Campaign Wise')}
              >
                View Campaign
              </Button>
            </Td>
            <Td>
              <div className="action-icon">
                <span
                  onClick={(e) => {
                    setshowHideModal({ ...showHideModal, email: { show: true } });
                  }}
                >
                  <BsEnvelopeFill />
                </span>
                <span>
                  <BsArrowDownCircle />
                </span>
                <span
                  onClick={(e) => {
                    setshowHideModal({ ...showHideModal, whatsapp: { show: true } });
                  }}
                >
                  <BsWhatsapp />
                </span>
              </div>
            </Td>
          </Tr>
        </Tbody>
      </Table> */}
    </>
  );
}
